@if (impersonationTarget(); as target) {
  <div
    class="impersonation-float"
    [class.impersonation-float--clickable]="canReselect()"
    [attr.role]="canReselect() ? 'button' : 'status'"
    [attr.tabindex]="canReselect() ? 0 : null"
    [attr.aria-label]="canReselect() ? 'Impersonation on — ' + target + '. Tap to switch pilot.' : null"
    aria-live="polite"
    (click)="reselect()"
    (keydown.enter)="reselect()"
    (keydown.space)="reselect()">
    <sara-icon
      icon="user-secret"
      variant="solid"></sara-icon>
    <span class="impersonation-float__text">Impersonation ON — {{ target }}</span>
    @if (canReselect()) {
      <span class="impersonation-float__hint">Tap to switch</span>
    }
  </div>
}
